import * as React from 'react';

function VIPStatusMatchIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 20 21" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.14 7.312l-.25.313-2 2.5-.78-.625 1.35-1.688H3v-1h11.46l-1.35-1.687.78-.625 2 2.5.25.312zm-13 5L3.39 12l2-2.5.781.625-1.35 1.687h11.46v1H4.82L6.17 14.5l-.78.625-2-2.5-.25-.313z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default VIPStatusMatchIcon;
